export default function getLinkAttribs(href, contentId, isEmbedded) {
  if (isEmbedded && contentId) {
    return {
      deviceUrl: `nbcnews://item/${contentId}`,
    };
  }

  return {
    href,
  };
}
